import { jsx as _jsx } from "react/jsx-runtime";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import cn from "../../utils/cn";
const Divider = ({ className, orientation = "horizontal", decorative = true, ...props }) => (_jsx(SeparatorPrimitive.Root, { "data-testid": "divider", decorative: decorative, orientation: orientation, className: cn("shrink-0 bg-border bg-gray-5", orientation === "horizontal" ? "h-px w-full" : "h-full w-px", className), ...props }));
Divider.displayName = SeparatorPrimitive.Root.displayName;
export default Divider;
